module.exports = __webpack_public_path__ + "img/mobile_not_support.657ca9f6.svg";